<template>
    <div :style="'width:' + iconWidth+ ';height:'+ iconHeight +';margin:' + iconMargin+';'">
        <v-layout>
            <v-flex v-if="directionIndicator=='D'">
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 510 510" :style="'fill:' + iconColor + ';enable-background:new 0 0 510 510;'" xml:space="preserve">
                    <g>
                        <g id="flights">
                            <path class="st0" d="M510,255c0-20.4-17.9-38.3-38.3-38.3H331.5L204,12.7h-51l63.8,204H76.5l-38.3-51H0L25.5,255L0,344.3h38.3
                                l38.3-51h140.3l-63.8,204h51l127.5-204h140.3C492.1,293.3,510,275.4,510,255z"/>
                        </g>
                    </g>
                </svg>
            </v-flex>
            <v-flex v-if="directionIndicator=='R'">
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 510 510" :style="'fill:' + iconColor + ';enable-background:new 0 0 510 510;'" xml:space="preserve">
                <g>
                    <g id="flights">
                        <path class="st0" d="M0,255c0,20.4,17.9,38.3,38.3,38.3h140.3l127.5,204h51l-63.8-204h140.3l38.3,51H510L484.5,255l25.5-89.3
                            h-38.3l-38.3,51H293.3l63.8-204h-51l-127.5,204H38.3C17.9,216.8,0,234.6,0,255z"/>
                    </g>
                </g>
                </svg>                
            </v-flex>
        </v-layout>

    </div>
</template>

<script>
import Theme from '../../theme';
export default {
    props:[
        'departureReturnIndicator','color','height','width', 'margin'
    ],
    computed:{
        directionIndicator(){
            return this.DepartureReturnIndicator==null? 'D':this.departureReturnIndicator;
        },
        iconColor(){
            return this.color==null? Theme.primary.base:this.color;
        },
        iconHeight(){
            return this.height == null? '24px':this.height;
        },
        iconWidth(){
            return this.width == null? '24px': this.width;
        },
        iconMargin(){
            return this.margin == null? '0 0 0 0': this.margin;
        }
    }
}
</script>

<style>

</style>
